<form [formGroup]="datosBasicosForm">
  <label class="mat-small last-review-date">Última revisión: {{datosBasicosForm.get('fechaActualiza').value}}</label>
  <h3 style="margin-bottom: 8px;">Datos de registro</h3>
  <div class="data-form-cont">
    <div class="data-form-field">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Fecha y lugar de nacimiento</mat-label>
        <input matInput formControlName="fechaLugarNacimiento" readonly>
      </mat-form-field>
    </div>

    <div class="data-form-field">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Documento</mat-label>
        <input matInput formControlName="identificacion" readonly>
      </mat-form-field>
    </div>

    <div class="data-form-field">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Tipo de sangre (RH)</mat-label>
        <input matInput formControlName="rhNombre" readonly>
      </mat-form-field>
    </div>
  </div>

  <!--
  <div class="data-form-cont">
    <div class="data-form-field">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Fecha de nacimiento</mat-label>
        <input matInput formControlName="fechaNac" [matDatepicker]="picker" placeholder="Fecha de nacimiento">
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
    </div>
    <div class="data-form-field">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>RH</mat-label>
        <mat-select formControlName="rh">
          <mat-option *ngFor="let tipo of rhs$ | async as rhs" [value]="tipo['key']">
            {{tipo['value']}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

      <div class="data-form-field">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Tipo de documento</mat-label>
          <mat-select formControlName="tipoDocumento" required>
            <mat-option *ngFor="let tipo of documentos$ | async as documentos" [value]="tipo['key']">
              {{tipo['value']}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="data-form-field">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Número de documento</mat-label>
          <input matInput formControlName="documento" required>
          <mat-error *ngIf="datosBasicosForm.get('documento').invalid">{{getErrorMessage('documento')}}
          </mat-error>
        </mat-form-field>
      </div>
      <div class="data-form-field">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Lugar de expedición</mat-label>
          <mat-select formControlName="lugarDocID" required>
            <mat-option *ngFor="let tipo of ciudades$ | async as ciudades" [value]="tipo['id']">
              {{tipo['nombre']}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  -->
</form>
